<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.live_tokens && billingStatuses && localService.deliveryTypes">
    <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
        [businesses]="localService.loggedMember.businesses"></app-business-deductive>
    <div *ngIf="businessId != '' && businessId != '0'">
        <app-activate-service *ngIf="wrapper && !wrapper.isEnabled" [businessId]="businessId"
            [additionalServiceType]="1" (onActivated)="onLoad()" [ctryCode]="ctryCode" [userId]="userId" />
        <div *ngIf="wrapper && wrapper.isEnabled">
            <div class="banner" *ngIf="isShowSettings">
                <div class="row freeze_height">
                    <div class="col-md-9">
                        <ngx-select [items]="billingStatuses" [optionValueField]="'key'" [optionTextField]="'value'"
                            [multiple]="true" placeholder="{{localService.languageContent.live_tokens.select_status}}"
                            [(ngModel)]="selectedStatuses" [noAutoComplete]="true" (select)="onAction(3)"
                            (remove)="onAction(3)" title="{{localService.languageContent.live_tokens.select_status}}">
                        </ngx-select>
                    </div>
                    <div class="col-md-3">
                        <div>
                            <label style="font-weight: normal; margin-left: 15px;">
                                <input type="checkbox" [(ngModel)]="isShowOnlyOwnLoginAssigned"
                                    (change)="onAction(3)" />
                                <span
                                    class="normal_color">{{localService.languageContent.live_tokens.is_show_only_login_user_assinged}}</span>
                            </label>
                        </div>
                        <div>
                            <label style="font-weight: normal; margin-left: 15px;">
                                <input type="checkbox" [(ngModel)]="isSelectAll" (change)="onAction(8)"
                                    [disabled]="isBillSelectionDisabled || wrapper.tokens.items.length == 0" />
                                <span
                                    class="normal_color">{{localService.languageContent.live_tokens.select_all}}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="wrapper" class="custom_rows_body" [ngStyle]="{'max-height' : (maxBodyHeight + 25) + 'px'}">
                <div class="row" style="margin-top: 20px;" *ngFor="let item of wrapper.tokens.items;index as i">
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-7 en">
                                <label style="font-weight: normal; margin-left: 15px;">
                                    <input type="checkbox" [(ngModel)]="item.isSelected"
                                        [disabled]="isBillSelectionDisabled" (change)="onAction(7,'',item.key)" />
                                    <span class="header token_num">{{item.v1}}</span>
                                    <span class="order-time">
                                        <i class="material-icons">access_time</i>
                                        {{item.v11 | date : 'hh:mm'}}
                                    </span>
                                </label>
                                <button class="button_icon button_icon_color"
                                    style="float: right;margin-top: -10px !important;"
                                    [ngStyle]="{'transform' : !item.isReadonly ? 'rotate(-90deg)' : 'rotate(90deg)'}"
                                    (click)="onAction(2,item.key)"
                                    title="{{ item.isReadonly ? localService.languageContent.live_tokens.hide_products : localService.languageContent.live_tokens.show_products}}">arrow_forward_ios</button>
                            </div>
                            <div class="col-5">
                                <span class="header">{{localService.getText(localService.billingStatus,item.v2)}}</span>
                                <i *ngIf="item.v7 == '1'" style="float: right;"
                                    class="material-icons bill_paid">paid</i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-6">
                                <div class="header customer_name" (click)="localService.showSummary(item.v8, 1)"
                                    [ngClass]="localService.getLanguageCode(item.v4)">
                                    {{item.v3 ? item.v3 : "-"}}</div>
                            </div>
                            <div class="col-6">
                                <span class="header">
                                    {{localService.getText(localService.deliveryTypes,item.v10)}}</span>
                                <a style="float: right;"
                                    [routerLink]="['/billing' + localService.basicParamsString,businessId,item.key]"
                                    class="material-icons button route_navigation">subdirectory_arrow_right</a>
                            </div>
                        </div>
                    </div>
                    <div class="products_body" *ngIf="!item.isReadonly">
                        <div class="row styled_row" *ngFor="let itemSub of onGetTokenProducts(item.key)"
                            (click)="onAction(7,itemSub.details.key,item.key)">
                            <div class="col-6">
                                <label class="product_select">
                                    <input type="checkbox" [(ngModel)]="itemSub.details.isSelected"
                                        (change)="onAction(7,itemSub.details.key,item.key)"
                                        [disabled]="isBillProductSelectionDisabled" />
                                    <span class="en">&nbsp;</span>
                                </label>
                                <span class="button en"
                                    (click)="localService.showSummary(itemSub.productId, 3)">{{itemSub.details.v2}}&nbsp;-&nbsp;</span>
                                <span [ngClass]="localService.getLanguageCode(itemSub.details.v6)">
                                    {{itemSub.details.v3}}</span>
                                <span
                                    class="en search_price">&nbsp;-&nbsp;({{onGetRemainingQty(itemSub.details.v1,itemSub.details.v25)}}&nbsp;</span>
                                <span
                                    class="search_price">{{localService.getText(localService.measurementTypes,itemSub.details.v5)}}</span>
                                <span class="en search_price">)&nbsp;</span>
                                <span class="en search_price" style="opacity: 0.6;"
                                    *ngIf="itemSub.details.v25 != '0' && itemSub.details.v25 != itemSub.details.v1">&nbsp;({{localService.languageContent.live_tokens.delivered_qty}}
                                    : {{itemSub.details.v25}}/{{itemSub.details.v1}})&nbsp;</span>
                                <span>{{itemSub.details.v13}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-paging *ngIf="wrapper" [paging]="wrapper.tokens.paging" [IsSimple]="true" [IsShowTotalCount]="true"
                [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()"></app-paging>
            <div class="footer_add_new" [ngStyle]="{'top' : 'calc(100% - '+ localService.getTopForAddNew() +'px'}">
                <button [disabled]="selectedBill.length == 0" class="btn btn-secondary" (click)="onAction(1)"
                    style="float: left;">
                    {{selectedBill.length}}&nbsp;
                    <span *ngIf="selectedBill.length > 0">{{isBillSelectionDisabled ? 'P' : 'B'}}&nbsp;</span>
                    {{selectedBilligStatusText}}
                </button>
                <button class="button_icon more_status" (click)="onAction(4)" style="float: left;"
                    title="{{localService.languageContent.live_tokens.more_status}}">more_horiz</button>
                <button class="button_icon button_icon_color" style="top: 2px;" (click)="onAction(9)">settings</button>
            </div>
        </div>
    </div>
    <div class="more_statuses_container" *ngIf="moreStatuses && isShowMoreStatus">
        <app-list-options [items]="moreStatuses" [selectedKey]="selectedBilligStatus" (onFocusOut)="onAction(5, $event)"
            (onSelectionChanged)="onAction(6)" />
    </div>
</div>